export default __webpack_public_path__ + "static/media/CAPWEB-Actualizacion-de-datos.42f9052f.pdf";